import { useState } from 'react';
import http from '../../../api/axios';
import Button from '../../../components/button/Button';
import { FileUpload } from '../../../components/files/FileUpload';
import { Modal } from '../../../components/modal/modal';
import { useTranslation } from '../../../context/translationContext';
import { useLoading } from '../../../context/loadingContext';
import { apiUrl } from '../../../api/apiUrl';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { toast } from 'react-toastify';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose: () => void;
}

/**
 * Modal form for uploading document to create documents
 */
export const InvoiceUploadToCreateModal = ({ open, setOpen, onClose }: Props) => {
  const { t } = useTranslation();
  const { company } = useCurrentCompany();
  const { loading, startLoading, stopLoading } = useLoading();
  const [selectedFile, setselectedFile] = useState<File[]>([]);
  const [mineAutomatically, setMineAutomatically] = useState<boolean>(false);

  /**
   * Uploads file
   * @returns
   */
  const handleSubmitFile = async () => {
    if (!selectedFile[0] || !company) return;
    try {
      startLoading();
      const apiPostFilesUrl = `${apiUrl.ACCOUNTING_DOCUMENT_CREATE_DOC_FROM_FILE}?companyId=${company.id}&mineAutomatically=${mineAutomatically}`;
      const formData = new FormData();
      formData.append('file', selectedFile[0]);
      const response = await http.apiPostFiles({
        url: apiPostFilesUrl,
        data: formData,
      });
      if (response?.status === 200) {
        stopLoading();
        onClose();
        toast.success('Success!');
        handleCloseModal();
      } else {
        stopLoading();
        handleCloseModal();
        toast.error('error');
      }
    } catch (err) {
      stopLoading();
      handleCloseModal();
      toast.error('error');
    }
  };

  /**
   * Closes modal
   */
  const handleCloseModal = () => {
    setOpen(false);
    setselectedFile([]);
  };

  return (
    <>
      <Modal open={open} title={t('page.invoice.upload-to-create')} onClose={() => setOpen(false)}>
        <div className="mt-3">
          <FileUpload
            showUploadButton={false}
            setSelectedFile={setselectedFile}
            selectedFile={selectedFile}
          />
        </div>
        <div className="w-full flex items-center mt-3 mb-3">
          <span>{t('page.invoice.to-be-mined-automatically')}</span>
          <input
            className="ml-3 w-5 h-5"
            name="mineAutomatically"
            type={'checkbox'}
            checked={mineAutomatically}
            onChange={(e) => setMineAutomatically(e.target.checked)}
          />
        </div>
        <Button
          title={t('general.upload')}
          className="bg-orange-600 hover:bg-orange-900 mr-3"
          onClick={handleSubmitFile}
          disabled={loading || !selectedFile[0] || !company}
        />
      </Modal>
    </>
  );
};
